import React, { useState, useEffect } from "react";
import { Container, Card, Form, Button, Row, Col, Nav, Table } from "react-bootstrap";
import { FaArrowLeft,FaCommentDots, FaCog, FaCalendarAlt, FaFileAlt,FaGlobe,FaCheckCircle, FaNewspaper, FaMicrochip, FaWindowClose} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { API_AGENTS_LIST, API_AGENT_GROUPS_LIST, API_VOICE_CAMPAIGNS_CREATE, API_IVR_LIST, API_NUMBERS_LIST, API_CONTACT_GROUP_LIST, API_WEBHOOK_LIST, API_SMSWEBHOOK_LIST, API_SCRIPTS_LIST, API_VOICE_CAMPAIGNS_GET_ONE, API_USERS_PROFILE, API_COMPANY_PROFILE } from "../../../service/url";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth, errorCheck } from "../auth/auth-utils";
import StatsBar from "./stats-bar";
import { ROUTES } from '../../../utilities/constant';
import { toast } from 'react-toastify';
import { BACKEND_API_BASE_URL} from "../../../utilities/constant";
import { getUser } from "../../../utilities/setting";
import Select from "react-select";
import { getCurrentTime, getCurrentDate } from "../../../utilities/helpers";

const CreateCampaign = () => {
  const { duplicate_camp_id } = useParams();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [numbersList, setNumbersList] = useState([]);
  const allDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const [parentAssignedCompany, setParentAssignedCompany] = useState(null);
  const [campaign, setCampaign] = useState({
    campaign_name: "",
    call_group:[],
    agentAssignment: "",
    selectedQueue: "",
    selectedAgents: [],
    scriptOption: "new",
    scriptTitle: "",
    scriptDescription: "",
    scriptShortDescription: "",
    selectedScript: "",
    callRecording: "do_not_record",
    did: [],
    timeBetweenCalls: "",
    max_retries: "",
    start_date: getCurrentDate(),
    end_date: "",
    weekDays: [],
    startHour: getCurrentTime(),
    endHour: "23:59",
    template_id: '',
    voice_file: "",
    menu_voice_file: "",
    dtmf: "",
    menu_wait_time: "",
    re_prompt: "",
    welcome_file: { enabled: false, selected: "" },
    no_input_file: { enabled: false, selected: "" },
    wrong_input_file: { enabled: false, selected: "" },
    thanks_file: { enabled: false, selected: "" },
    no_agent_file: { enabled: false, selected: "" },
    selectedQueue: "",
    selectedDtmf: "",
    assignedQueues: [],
    campaign_type: "",
    ivr:"",
    sendSmsOnSuccess: false,
    duration: 1,
    successSmsWebhook: "",
    sendSmsOnFail: false,
    failSmsWebhook: "",
    enableWebhook: false,
    webhook: "",
    enableSmsOnDtmf: false,
    smsOnDtmf: "",
    enableSmsOnPatchSuccess: false,
    smsOnPatchSuccess: "",
    enableSmsOnPatchFailed: false,
    smsOnPatchFailed: "",
    locations: [],
  });
  const [selectAll, setSelectAll] = useState(false);
  const [callGroupList, setCallGroupList] = useState([]);
  const [contactGroupList, setContactGroupList] = useState([]);
  const [agentsList, setAgentsList] = useState([]);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [welcomeFileList, setWelcomeFileList] = useState([]);
  const [menuFileList, setMenuFileList] = useState([]);
  const [thanksFileList, setThanksFileList] = useState([]);
  const [noInputFileList, setNoInputFileList] = useState([]);
  const [wrongInputFileList, setWrongInputFileList] = useState([]);
  const [noAgentFileList, setNoAgentFileList] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [error, setError] = useState("");
  const [ivrList, setIvrList] = useState([]);
  const [webhooks, setWebhooks] = useState([]);
  const [smsWebhooks, setSmsWebhooks] = useState([]);
  const [scripts, setScripts] = useState([]);
  const [invalidSteps, setInvalidSteps] = useState([]);
  const [user, setUser] = useState(null);

  const handleDayChange = (day, checked) => {
    setCampaign((prev) => ({
      ...prev,
      weekDays: checked
        ? [...prev.weekDays, day]
        : prev.weekDays.filter((d) => d !== day),
    }));
  };

  const handleSelectAllToggle = () => {
    if (selectAll) {
      setCampaign((prev) => ({ ...prev, weekDays: [] }));
    } else {
      setCampaign((prev) => ({ ...prev, weekDays: allDays }));
    }
    setSelectAll(!selectAll);
  };


  const handleFormSubmit = async () => {
    try {
      setButtonDisable(true);

      if (!validateForm()) {
         setButtonDisable(false);
         return;
      }
      let scriptData;
      if (campaign.scriptOption === "new") {
        scriptData = {
          title: campaign.scriptTitle,
          description: campaign.scriptDescription,
          short_description: campaign.scriptShortDescription,
        }
      } else if (campaign.scriptOption === "existing") {
        scriptData = campaign.selectedScript;
      } else {
        scriptData = null;
      }

      let selectedAgentsData;
      if (campaign.agentAssignment === "queue") {
        selectedAgentsData = [];
      } else {
        selectedAgentsData = campaign.selectedAgents;
      }
      const payload = {
        ...campaign,
        selectedAgents: selectedAgentsData,
        member_schedule: {
          start_time: campaign.startHour,
          end_time: campaign.endHour,
          week_days: campaign.weekDays,
        },
        script: scriptData
      };

      postApiCall(API_VOICE_CAMPAIGNS_CREATE, payload)
        .then(onCreateCampSuccess)
        .catch(onCreateCampError);
    } catch (error) {
      console.error("Error submitting campaign:", error);
    }
  };

  useEffect(() => {
    if (campaign.agentAssignment === "all") {
      getApiCall(API_AGENTS_LIST, {})
        .then((data) => {
          if (data.length > 0) {
            const agentIds = data.map((item) => {
              return item.id;
            });
            setCampaign((prev) => ({
              ...prev,
              selectedAgents: agentIds,
            }));
          }
        })
        .catch((error) => {
          // setToastProps({ message: JSON.stringify(error), type: "danger" });
              toast.error(JSON.stringify(error));
        });
    }
  }, [campaign.agentAssignment, campaign.call_group]);

function onCreateCampSuccess(resp){
  // setToastProps({message: 'Campaign created successfully', type: 'success'});
      toast.success("Outbound Campaign created successfully");
  setTimeout( () => {
    navigate(`/${ROUTES.CAMPAIGNS.LIST}`);
  }, 1500);
}

function onCreateCampError(err) {
  if (typeof err !== "object" && err.includes("TokenExpiredError")) {
    errorCheck(err, navigate, setToastProps, setShowToast);
  } else {
    setButtonDisable(false);
    // setToastProps({ message: JSON.stringify(err), type: "danger" });
        toast.error(JSON.stringify(err));
  }
}

  function onCallGroupListSuccess(resp) {
    setCallGroupList(resp);
  }

  function onContactGroupListSuccess(resp) {
    setContactGroupList(resp);
  }

  function onScriptsListSuccess(resp) {
    setScripts(resp);
  }

  function onAgentsListSuccess(resp) {
    setAgentsList(resp);
  }

  function onIvrListSuccess(resp) {
    setIvrList(resp);
  }

  useEffect(() => {
    getApiCall(API_AGENT_GROUPS_LIST, {})
      .then(onCallGroupListSuccess)
      .catch(onError);

    getApiCall(API_CONTACT_GROUP_LIST, {})
      .then(onContactGroupListSuccess)
      .catch(onError);

    getApiCall(API_AGENTS_LIST, {}).then(onAgentsListSuccess).catch(onError);

    getApiCall(API_IVR_LIST, {})
     .then(onIvrListSuccess)
     .catch(onError)

    getApiCall(API_NUMBERS_LIST)
      .then(onNumberListSuccess)
      .catch(onError)

    getApiCall(API_WEBHOOK_LIST)
      .then(onWebhookListSuccess)
      .catch(onError)
    
    getApiCall(API_SMSWEBHOOK_LIST)
      .then(onSmsWebhookListSuccess)
      .catch(onError)

    getApiCall(API_SCRIPTS_LIST, {})
      .then(onScriptsListSuccess)
      .catch(onError);

    getUser().then((resp) => {
          if (resp) {
            setLoggedInUser(resp.id);
            setUser(resp);
            if (resp && resp.createdByUser) {
              if (resp.createdByUser.assigned_company) {
                setParentAssignedCompany(resp.createdByUser.assigned_company);
              } 
            }
          }
        });
  }, []);

  useEffect(() => {
      if (loggedInUser) {
        getApiCall(`${BACKEND_API_BASE_URL}/v2/prompt?prompt_status=1&user_id=${loggedInUser}`)
        .then(onPromptsSuccess)
        .catch(onError)
      }
  }, [loggedInUser]);

  useEffect(() => {
    const fetchParentAssignedCompanyDetails = async () => {
      if (!parentAssignedCompany || !user) return;
      try {
        const url = API_COMPANY_PROFILE.replace(":id", parentAssignedCompany);
        const companyDetails = await getApiCall(url, {});
        if (companyDetails && companyDetails?.companyLocations) {
          setUser(prevUser => ({
            ...prevUser,
            userLocations: companyDetails.companyLocations
          }));
        }
        console.log("companyDetails", companyDetails);
      } catch(error) {
        console.log("error fetching parent assigned company details:", error);
      }
    }
    fetchParentAssignedCompanyDetails();
  }, [user, parentAssignedCompany]);

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };
    
  function onPromptsSuccess(resp) {
      if (!resp || !Array.isArray(resp)) return;
  
      const welcomeFiles = resp.filter(item => item.prompt_category === "Welcome");
      const menuFiles = resp.filter(item => item.prompt_category === "Menu");
      const thanksFiles = resp.filter(item => item.prompt_category === "Thanks");
      const noInputFiles = resp.filter(item => item.prompt_category === "No Input");
      const noAgentFiles = resp.filter(item => item.prompt_category === "No Agent");
      const wrongInputFiles = resp.filter(item => item.prompt_category === "Wrong Input");
      setWelcomeFileList(welcomeFiles);
      setMenuFileList(menuFiles);
      setThanksFileList(thanksFiles);
      setNoInputFileList(noInputFiles);
      setWrongInputFileList(wrongInputFiles);
      setNoAgentFileList(noAgentFiles)
  }

    function onError(err) {
      console.log(err);
  }

  function onNumberListSuccess(resp) {
    setNumbersList(resp);
  }

  function onWebhookListSuccess(resp) {
    setWebhooks(resp);
  }

  function onSmsWebhookListSuccess(resp) {
    setSmsWebhooks(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const handleChange = (e) => {
    let { name, value, type, checked } = e.target;

    if (name === "max_retries") {
      const num = parseInt(value);
      if (num > 10) value = 10;
      if (num < 1) value = 1;
    }

    
    if (name === "timeBetweenCalls") {
      let num = parseInt(value);
      if (num < 0) num = 0;
      value = num;
    }

    // Validation for campaign_name (letters, numbers, underscore only)
    if (name === "campaign_name") {
      const onlyValid = value.replace(/[^a-zA-Z0-9_]/g, "");
      if (value !== onlyValid) {
        setError("Only letters, numbers, and underscore (_) are allowed.");
      } else {
        setError("");
      }
      value = onlyValid;
    }

    // Update state
    setCampaign((prev) => {
      const updated = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (updated.start_date && updated.end_date) {
        if (updated.start_date === updated.end_date) {
          const dateObj = new Date(updated.start_date);
          const weekday = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ][dateObj.getDay()];

          updated.weekDays = [weekday];
        } else {
          updated.weekDays = prev.weekDays || [];
        }
      }
      return updated;
    });
  };

const nextStep = () => {
  if (step == 1) {
    if (!campaign.campaign_type.trim()) {
      toast.error("Dialer Type is required");
      return;
    }
  }
  if (step == 2) {
    if (!campaign.template_id.trim() && campaign.campaign_type == 2) {
      toast.error("Template is required");
      return;
    }
  }

  const isValid = validateStep(step);

  if (!isValid) {
    if (!invalidSteps.includes(step)) {
      setInvalidSteps((prev) => [...prev, step]);
    }

    if (completedSteps.includes(step)) {
      setCompletedSteps((prev) => prev.filter((s) => s !== step));
    }

  } else {
    if (invalidSteps.includes(step)) {
      setInvalidSteps((prev) => prev.filter((s) => s !== step));
    }

    if (!completedSteps.includes(step)) {
      setCompletedSteps((prev) => [...prev, step]);
    }
  }

  if (step == 1 && campaign.campaign_type != 2) {
      setStep(3);
    } else {
      setStep((prev) => prev + 1);
  }
};

const prevStep = () => {
  // Handle backward navigation
  if (step === 7 && campaign.campaign_type == 2) {
    setStep(6); // From SmsWebhook back to Schedule
  } else {
    setStep((prev) => prev - 1);
  }
};


  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  function validateForm() {
    let valid = true;
    if (!campaign?.template_id?.trim() && campaign.campaign_type == 2) {
      valid = false;
      // setToastProps({ message: "Template is required", type: "danger" });
          toast.error("Template is required");
    } 
    else if (!campaign?.campaign_name?.trim()) {
      valid = false;
      // setToastProps({ message: "Campaign Name required", type: "danger" });
          toast.error("Outbound Campaign Name required");
    }
    else if (!campaign.call_group.length > 0) {
      valid = false;
      // setToastProps({ message: "Call Group required", type: "danger" });
          toast.error("Call Group required");
    }
    // else if (campaign.agentAssignment === "queue" && campaign.template_id != 3) {
    //   if (!campaign.selectedQueue.trim()) {
    //     valid = false;
    //         SweetAlert({
    //         text: "Selected Queue required",
    //         icon: "warning",
    //       });
    //   }
    // }
    else if (campaign.agentAssignment === "agents") {
      if (campaign.selectedAgents.length < 1) {
        valid = false;
        // setToastProps({ message: "Selected Agents required", type: "danger" });
            toast.error("Selected Agents required");
      }
    }
    else if (campaign.scriptOption === "new") {
      if (!campaign?.scriptTitle?.trim()) {
        valid = false;
        // setToastProps({ message: "New Script Title required", type: "danger" });
            toast.error("New Script Title required");
      }
      else if (!campaign?.scriptDescription?.trim()) {
        valid = false;
        // setToastProps({ message: "New Script Description required", type: "danger" });
            toast.error("New Script Description required");
      }
      else if (!campaign?.scriptShortDescription?.trim()) {
        valid = false;
        // setToastProps({ message: "New Script Short Description required", type: "danger" });
            toast.error("New Script Short Description required");
      }
    }
    else if (campaign.scriptOption === "existing") {
      if (!campaign.selectedScript) {
        valid = false;
        // setToastProps({ message: "Existing Script required", type: "danger" });
            toast.error("Existing Script required");
      }
    }
    else if (!campaign.did.length > 0) {
      valid = false;
          toast.error("Outbound Campaign DID required");
    }
    else if (!campaign.timeBetweenCalls) {
      valid = false;
      // setToastProps({ message: "Time Between Calls required", type: "danger" });
          toast.error("Time Between Calls required");
    }
    else if (!campaign.max_retries) {
      valid = false;
      // setToastProps({ message: "Max Retries required", type: "danger" });
          toast.error("Max Retries required");
    }
    else if (!campaign.start_date) {
      valid = false;
      // setToastProps({ message: "Campaign Start Date required", type: "danger" });
          toast.error("Outbound Campaign Start Date required");
    }
    else if (!campaign.end_date) {
      valid = false;
      // setToastProps({ message: "Campaign End Date required", type: "danger" });
          toast.error("Outbound Campaign End Date required");
    }
    else if (campaign.weekDays.length < 1) {
      valid = false;
      // setToastProps({ message: "At least 1 Week Day for campaign is required", type: "danger" });
          toast.error("At least 1 Week Day for outbound campaign is required");
    }
    else if (!campaign.startHour) {
      valid = false;
      // setToastProps({ message: "Campaign Start Hour required", type: "danger" });
          toast.error("Outbound Campaign Start Hour required");
    }
    else if (!campaign.endHour) {
      valid = false;
      // setToastProps({ message: "Campaign End Hour required", type: "danger" });
          toast.error("Outbound Campaign End Hour required");
    }
    else if (campaign.template_id == 0 && !campaign.voice_file) {
      valid = false;
      // setToastProps({ message: "Campaign Voice File is required", type: "danger" });
          toast.error("Outbound Campaign Voice File is required");
    }     
    else if (campaign.template_id == 1 || campaign.template_id == 2) {
      if (!campaign.menu_voice_file) {
        valid = false;
        // setToastProps({ message: "Campaign Menu Voice File is required", type: "danger" });
            toast.error("Outbound Campaign Menu Voice File is required");
      } else if (!campaign.dtmf && campaign.template_id == 1) {
        valid = false;
        // setToastProps({ message: "DTMF is required", type: "danger" });
            toast.error("DTMF is required");
      } else if (!campaign.menu_wait_time) {
        valid = false;
        // setToastProps({ message: "Menu Wait Time is required", type: "danger" });
            toast.error("Menu Wait Time is required");
      } else if (!campaign.re_prompt) {
        valid = false;
        // setToastProps({ message: "Re-Prompt is required", type: "danger" });
            toast.error("Re-Prompt is required");
        
      } else if (campaign.welcome_file.enabled && !campaign.welcome_file.selected) {
        valid = false;
        // setToastProps({ message: "Welcome File is required", type: "danger" });
            toast.error("Welcome File is require");
      } else if (campaign.no_input_file.enabled && !campaign.no_input_file.selected) {
        valid = false;
        // setToastProps({ message: "No Input File is required", type: "danger" });
            toast.error("No Input File is required");
      } else if (campaign.wrong_input_file.enabled && !campaign.wrong_input_file.selected) {
        valid = false;
        // setToastProps({ message: "Wrong Input File is required", type: "danger" });
            toast.error("Wrong Input File is required");
      } else if (campaign.thanks_file.enabled && !campaign.thanks_file.selected) {
        valid = false;
        // setToastProps({ message: "Thanks File is required", type: "danger" });
            toast.error("Thanks File is required");
      }

      if (campaign.template_id == 2) {
        // if (campaign.no_agent_file.enabled && !campaign.no_agent_file.selected) {
        if (!campaign.no_agent_file.selected) {
          valid = false;
          // setToastProps({ message: "No Agent File is required", type: "danger" });
              toast.error("No Agent File is required");
        } else if (campaign.assignedQueues.length === 0) {
          valid = false;
          // setToastProps({ message: "Assigned Queue is required", type: "danger" });
            toast.error("Assigned Queue is required");
        }
      }
    }     
    if (!campaign.locations || campaign.locations.length === 0) {
  valid = false;
  toast.error("Please select at least one Location.");
}

    if (campaign.sendSmsOnSuccess && !campaign.successSmsWebhook) {
      valid = false;
      toast.error("Please select a Success SMS Webhook.");
    }

    if (campaign.sendSmsOnFail && !campaign.failSmsWebhook) {
      valid = false;
      toast.error("Please select a Fail SMS Webhook.");
    }

    if (campaign.enableWebhook && !campaign.webhook) {
      valid = false;
      toast.error("Please select a Webhook.");
    }

    if (campaign.enableSmsOnDtmf && !campaign.smsOnDtmf) {
      valid = false;
      toast.error("Please select a DTMF SMS Webhook.");
    }

    if (campaign.enableSmsOnPatchSuccess && !campaign.smsOnPatchSuccess) {
      valid = false;
      toast.error("Please select a Patch Success SMS Webhook.");
    }

    if (campaign.enableSmsOnPatchFailed && !campaign.smsOnPatchFailed) {
      valid = false;
      toast.error("Please select a Patch Fail SMS Webhook.");
    }

    if (campaign.template_id == 3 && !campaign.ivr) {
      valid = false;
      toast.error("Please select IVR");
    }

    if (campaign.startHour === campaign.endHour) {
      valid = false;
      toast.error("Please select different outbound campaign hours");
    }

    const start = timeToMinutes(campaign.startHour);
    const end = timeToMinutes(campaign.endHour);

    if (end <= start) {
      valid = false;
      toast.error("End Outbound Campaign Hour cannot be before Start Outbound Campaign Hour");
    }
    return valid;
  }

useEffect(() => {
  if (duplicate_camp_id) {
    const url = API_VOICE_CAMPAIGNS_GET_ONE.replace(":id", duplicate_camp_id);

    getApiCall(url, {})
      .then((resp) => {
        if (resp.campaign_type && typeof resp.campaign_type !== "string") {
          resp.campaign_type = String(resp.campaign_type);
        }

        if (resp.is_recording == 0) {
          resp.callRecording = "do_not_record";
        } else {
          resp.callRecording = "record";
        }

        if (resp.time_between_call) {
          resp.timeBetweenCalls = resp.time_between_call;
        }

        if (resp.campaign_name) {
          resp.campaign_name = "";
        }

        const schedule = resp.voice_campaigns_schedule?.[0] || {};

        // const locationValues = resp.campaignLocations?
        //   ? {
        //     location_id: resp.campaignLocations[0].location_id,
        //     location_name: resp.campaignLocations[0].location_name,
        //   }
        //   : { location_id: "", location_name: "" };

        const { campaign_id, user_id, schedule_date, campaign_status, start_hours, end_hours, script_id, dtmf_count, dtmf1_count, dtmf2_count, is_recording, prompt_duration, sms_text, sms_count, trunk, context, total_nos, nos_processed, connected_calls, agents, is_retry, retry_interval, auto_retry_count, time_between_call, invalid_retry, unit_rate, channels, pulses, pulse_duration, parent_pulse_duration, s_parent_pulse_duration, base_id, parent_id, s_parent_id, country_code, dnd_count, error_desc, target_type, type_run, first_call, is_deleted, created_at, updated_at, ...restResp } = resp;

        const mappedCampaign = {
          ...restResp,
          sms_text: resp.sms_text || "",
          startHour: schedule.start_time || "",
          endHour: schedule.end_time || "",
          weekDays: Array.isArray(schedule.week_days) ? schedule.week_days : [],
          start_date: resp.start_date || "",
          end_date: resp.end_date || "",
          max_retries: resp.max_retries || "",
          timeBetweenCalls: resp.time_between_call || "2",
          did: (resp.campaign_numbers || []).map(n => n.number_details_data?.id).filter(Boolean),
          call_group: (resp.campaign_contact_group || []).map(g => String(g.contact_group_id)),
          locations:resp.campaignLocations?.map((loc) => ({
              id: loc.location_id,
              location_name: loc.location_name,
              })),
          // location_id: locationValues.location_id,
          // location_name: locationValues.location_name,
          successSmsWebhook: "",
          failSmsWebhook: "",
          webhook: "",
          scriptOption: "none",
          selectedScript: "",
          voice_file: "",
          menu_voice_file: "",
          duration: "", 
          assignedQueues: [],
        };

        if (resp.template_id == 0 || resp.template_id == 1) {
          mappedCampaign.selectedQueue = resp?.voice_campaigns_call_group_details[0]?.call_group_id;
          mappedCampaign.agentAssignment = "queue";
        }

        if (Array.isArray(resp.voice_campaign_webhook_details)) {
          const connectedWebhook = resp.voice_campaign_webhook_details.find(w => w.event === "CALL_CONNECTED");
          const failedWebhook = resp.voice_campaign_webhook_details.find(w => w.event === "CALL_FAILED");
          const generalWebhook = resp.voice_campaign_webhook_details.find(w => (w.event === "CONNECTED_CALLS" || w.event === "HANGUP" || w.event === "DTMF"));
          const dtmfWebhook = resp.voice_campaign_webhook_details.find(w => w.event === "VALID_DTMF");
          const patchFailedWebhook = resp.voice_campaign_webhook_details.find(w => w.event === "PATCH_FAILED");
          const patchConnectedWebhook = resp.voice_campaign_webhook_details.find(w => w.event === "PATCH_CONNECTED");
          
          mappedCampaign.successSmsWebhook = connectedWebhook?.sms_webhook_id || "";
          mappedCampaign.failSmsWebhook = failedWebhook?.sms_webhook_id || "";
          mappedCampaign.webhook = generalWebhook?.webhook_id || "";
          mappedCampaign.duration = connectedWebhook?.duration || "";
          mappedCampaign.smsOnDtmf = dtmfWebhook?.sms_webhook_id || "";
          mappedCampaign.smsOnPatchSuccess = patchConnectedWebhook?.sms_webhook_id || "";
          mappedCampaign.smsOnPatchFailed = patchFailedWebhook?.sms_webhook_id || "";
        }

        mappedCampaign.sendSmsOnSuccess = !!mappedCampaign.successSmsWebhook;
        mappedCampaign.sendSmsOnFail = !!mappedCampaign.failSmsWebhook;
        mappedCampaign.enableWebhook = !!mappedCampaign.webhook;
        mappedCampaign.enableSmsOnDtmf = !!mappedCampaign.smsOnDtmf;
        mappedCampaign.enableSmsOnPatchSuccess = !!mappedCampaign.smsOnPatchSuccess;
        mappedCampaign.enableSmsOnPatchFailed = !!mappedCampaign.smsOnPatchFailed;

        if (resp.voice_campaigns_scripts_details) {
          mappedCampaign.scriptOption = "existing";
          mappedCampaign.selectedScript = resp.voice_campaigns_scripts_details.id;
        } else {
          mappedCampaign.scriptOption = "none";
        }

        if (resp.template_id == "0" && resp.campaigns?.length > 0) {
          mappedCampaign.voice_file = resp.campaigns[0]?.value || "";
        } else if (["1", "2"].includes(resp.template_id) && resp.campaigns?.length > 0) {
          const menuCampaign = resp.campaigns.find(c => c.name === "menu");
          mappedCampaign.menu_voice_file = menuCampaign ? menuCampaign.value : "";
        }

        if ((resp.template_id === "1" || resp.template_id === "2") && resp.campaigns?.length > 0) {
          const fileMappings = {
            welcome_file: "welcome",
            no_input_file: "noinput",
            wrong_input_file: "wronginput",
            thanks_file: "thanks",
            no_agent_file: "noagent",
          };

          Object.entries(fileMappings).forEach(([stateKey, campaignName]) => {
            const match = resp.campaigns.find(c => c.name === campaignName);
            mappedCampaign[stateKey] = {
              enabled: !!match,      
              selected: match ? match.value : ""  
            };
          });
        }

        if (resp.template_id === "2" && resp.voice_campaigns_call_group_details?.length > 0) {
          mappedCampaign.agentAssignment = "queue";
          mappedCampaign.assignedQueues = resp.voice_campaigns_call_group_details.map(item => ({
            queueId: item.call_group_id,
            queueName: item.agent_group_campaign_details?.group_name || "",
            dtmf: item.dtmf || "",
          }));
        }
        setCampaign(mappedCampaign);
      })
      .catch((error) => {
        console.error("❌ Failed to fetch duplicate campaign:", error);
      });
  }
}, [duplicate_camp_id]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />
            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Select Dialer Type
              </Form.Label>
              <Form.Select
                name="campaign_type"
                value={campaign.campaign_type}
                onChange={handleChange}
                style={{
                  padding: "0.5rem 0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
              >
                <option value="">Choose a Dialer Type</option>
                <option value="1">Click2Call</option>
                <option value="2">Auto Dialer</option>
                <option value="3">Predictive Dialer</option>
                <option value="4">Power Dialer</option>
              </Form.Select>
            </Form.Group>
          </div>
        );
      case 2:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />
            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Select Template
              </Form.Label>
              <Form.Select
                name="template_id"
                value={campaign.template_id}
                onChange={handleChange}
                style={{
                  padding: "0.5rem 0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
              >
                <option value="">Choose a template</option>
                <option value="0">Simple IVR</option>
                <option value="1">DTMF</option>
                <option value="2">Call Patch</option>
                {campaign.campaign_type == 2 && (
                  <option value="3">Custom IVR</option>
                )}
              </Form.Select>
            </Form.Group>
          </div>
        );
      case 3:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Outbound Campaign name
              </Form.Label>
              <Form.Control
                type="text"
                name="campaign_name"
                value={campaign.campaign_name}
                onChange={handleChange}
                placeholder="Create a suitable name for the outbound campaign"
                style={{
                  padding: "0.5rem 0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  transition:
                    "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                }}
              />
              {error && (
                <small style={{ color: "red", marginTop: "4px" }}>
                  {error}
                </small>
              )}
            </Form.Group>
            <Form.Group style={{ marginBottom: "1.5rem" }}>
  <Form.Label
    style={{
      fontWeight: 500,
      color: "#495057",
      marginBottom: "0.5rem",
    }}
  >
    Select Location
  </Form.Label>
  <Select
    isMulti
    name="locations"
    options={user?.userLocations?.map((ul) => 
      
      ({
      value: ul.locations.location_id,
      label: ul.locations.location_name,
    })
  
  )}
    value={campaign.locations?.map((loc) => ({
      value: loc.id ,
      label: loc.location_name,
     }))} 

    onChange={(selectedOptions) => {

      const formatted = selectedOptions.map((opt) => ({
        id: opt.value,
        location_name: opt.label,
      }));

      setCampaign((prev) => ({
        ...prev,
        locations: formatted,
      }));
    }}
    styles={{
      control: (base) => ({
        ...base,
        padding: "2px",
        borderRadius: "6px",
        border: "1px solid #ced4da",
      }),
    }}
    placeholder="Choose Locations"
  />
</Form.Group>

            {campaign.template_id == 0 && (
              <Form.Group style={{ marginBottom: "1.5rem" }}>
                <Form.Label
                  style={{
                    fontWeight: 500,
                    color: "#495057",
                    marginBottom: "0.5rem",
                  }}
                >
                  Upload Voice File
                </Form.Label>
                <Form.Select
                  name="voice_file"
                  value={campaign.voice_file}
                  onChange={handleChange}
                  style={{
                    padding: "0.5rem 0.75rem",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    transition:
                      "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                  }}
                >
                  <option>Select...</option>
                  {welcomeFileList.map((file) => (
                    <option key={file.id} value={file.id}>
                      {file.prompt_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}

            {(campaign.template_id == 1 || campaign.template_id == 2) && (
              <>
                <Form.Group style={{ marginBottom: "1.5rem" }}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Upload Menu Voice File
                  </Form.Label>
                  <Form.Select
                    name="menu_voice_file"
                    value={campaign.menu_voice_file}
                    onChange={handleChange}
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                    }}
                  >
                    <option>Select Menu Voice File</option>
                    {menuFileList.map((file) => (
                      <option key={file.id} value={file.id}>
                        {file.prompt_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  {campaign.template_id == 1 && (
                    <Form.Group style={{ flex: 1 }}>
                      <Form.Label style={{ fontWeight: 500, color: "#495057" }}>
                        DTMF
                      </Form.Label>
                      <Select
                        isMulti
                        name="dtmf"
                        options={[...Array(10).keys()].map((num) => ({
                          value: num.toString(),
                          label: num.toString(),
                        }))}
                        value={
                          campaign.dtmf
                            ? campaign.dtmf.split(",").map((val) => ({
                                value: val.trim(),
                                label: val.trim(),
                              }))
                            : []
                        }
                        onChange={(selected) => {
                          setCampaign((prev) => ({
                            ...prev,
                            dtmf: selected.map((opt) => opt.value).join(","),
                          }));
                        }}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "2px",
                          }),
                        }}
                      />
                    </Form.Group>
                  )}

                  <Form.Group style={{ flex: 1 }}>
                    <Form.Label style={{ fontWeight: 500, color: "#495057" }}>
                      Menu Wait Time
                    </Form.Label>
                    <Form.Select
                      name="menu_wait_time"
                      value={campaign.menu_wait_time}
                      onChange={handleChange}
                      style={{
                        padding: "0.5rem 0.75rem",
                        borderRadius: "6px",
                        border: "1px solid #ced4da",
                      }}
                    >
                      <option value="">Select Menu Wait Time</option>
                      {[...Array(10).keys()].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group style={{ flex: 1 }}>
                    <Form.Label style={{ fontWeight: 500, color: "#495057" }}>
                      Re-Prompt
                    </Form.Label>
                    <Form.Select
                      name="re_prompt"
                      value={campaign.re_prompt}
                      onChange={handleChange}
                      style={{
                        padding: "0.5rem 0.75rem",
                        borderRadius: "6px",
                        border: "1px solid #ced4da",
                      }}
                    >
                      <option value="">Select Re-Prompt</option>
                      {[...Array(4).keys()].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  {[
                    {
                      name: "welcome_file",
                      label: "Welcome File",
                      list: welcomeFileList,
                    },
                    {
                      name: "no_input_file",
                      label: "No Input File",
                      list: noInputFileList,
                    },
                    {
                      name: "wrong_input_file",
                      label: "Wrong Input File",
                      list: wrongInputFileList,
                    },
                    {
                      name: "thanks_file",
                      label: "Thanks File",
                      list: thanksFileList,
                    },
                    ...(campaign.template_id == 2
                      ? [
                          {
                            name: "no_agent_file",
                            label: "No Agent File",
                            list: noAgentFileList,
                          },
                        ]
                      : []),
                  ].map((item) => (
                    <div key={item.name} style={{ flex: 1 }}>
                      <Form.Check
                        type="checkbox"
                        label={item.label}
                        checked={campaign[item.name]?.enabled || false}
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: item.name,
                              value: {
                                enabled: e.target.checked,
                                selected: "",
                              },
                            },
                          })
                        }
                      />

                      {/* Dropdown when checked */}
                      {campaign[item.name]?.enabled && (
                        <Form.Select
                          value={campaign[item.name]?.selected || ""}
                          onChange={(e) =>
                            handleChange({
                              target: {
                                name: item.name,
                                value: {
                                  ...campaign[item.name],
                                  selected: e.target.value,
                                },
                              },
                            })
                          }
                          style={{ marginTop: "0.5rem" }}
                        >
                          <option value="">Select file {item.label}</option>
                          {item.list.map((file) => (
                            <option key={file.id} value={file.id}>
                              {file.prompt_name}
                            </option>
                          ))}
                        </Form.Select>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Select contact group
              </Form.Label>
              <Select
                isMulti
                name="call_group"
                options={contactGroupList.map((group) => ({
                  value: group.id,
                  label: group.group_name,
                }))}
                value={contactGroupList
                  .filter((group) => campaign.call_group?.includes(group.id))
                  .map((group) => ({
                    value: group.id,
                    label: group.group_name,
                  }))}
                onChange={(selected) => {
                  setCampaign((prev) => ({
                    ...prev,
                    call_group: selected.map((opt) => opt.value),
                  }));
                }}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    padding: "2px",
                  }),
                }}
              />
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              {/* <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Assign agents
              </Form.Label> */}
              <div>
                {/* <Form.Check
                  type="radio"
                  id="allAgents"
                  label="All agents"
                  name="agentAssignment"
                  value="all"
                  checked={campaign.agentAssignment === "all"}
                  onChange={handleChange}
                  style={{ marginBottom: "0.75rem" }}
                /> */}
                {(campaign.template_id == 0 ||
                  campaign.template_id == 1 ||
                  campaign.campaign_type != 2) && (
                  <>
                    <Form.Check
                      type="checkbox"
                      id="selectQueue"
                      label="Select Call Group"
                      name="agentAssignment"
                      value="queue"
                      checked={campaign.agentAssignment === "queue"}
                      onChange={(e) =>
                        setCampaign((prev) => ({
                          ...prev,
                          agentAssignment: prev.agentAssignment === "queue" ? "" : "queue",
                        }))
                      }
                      style={{ marginBottom: "0.75rem" }}
                    />
                    {campaign.agentAssignment === "queue" && (
                      <Form.Select
                        style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                        name="selectedQueue"
                        value={campaign.selectedQueue}
                        onChange={handleChange}
                      >
                        <option>Select Call Group...</option>
                        {callGroupList.map((center) => (
                          <option key={center.id} value={center.id}>
                            {center.group_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}

                    {/* <Form.Check
                      type="radio"
                      id="selectAgents"
                      label="Select agents"
                      name="agentAssignment"
                      value="agents"
                      checked={campaign.agentAssignment === "agents"}
                      onChange={handleChange}
                      style={{ marginBottom: "0.75rem" }}
                    />
                    {campaign.agentAssignment === "agents" && (
                      <Form.Select
                        style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                        name="selectedAgents"
                        value={campaign.selectedAgents}
                        onChange={handleChange}
                      >
                        <option>Select Agents...</option>
                        {agentsList.map((agent) => (
                          <option key={agent.id} value={agent.id}>
                            {agent.agent_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}                  */}
                  </>
                )}

                {campaign.template_id == 2 && (
                  <>
                    <Form.Check
                      type="checkbox"
                      id="selectQueue"
                      label="Select Call Group"
                      name="agentAssignment"
                      value="queue"
                      checked={campaign.agentAssignment === "queue"}
                      onChange={(e) =>
                        setCampaign((prev) => ({
                          ...prev,
                          agentAssignment: prev.agentAssignment === "queue" ? "" : "queue",
                        }))
                      }
                      style={{ marginBottom: "0.75rem" }}
                    />

                    {campaign.agentAssignment === "queue" && (
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                          marginTop: "0.5rem",
                        }}
                      >
                        {/* Queue Dropdown */}
                        <Form.Select
                          style={{ flex: 2 }}
                          name="selectedQueue"
                          value={campaign.selectedQueue}
                          onChange={handleChange}
                        >
                          <option value="">Select Call Group...</option>
                          {callGroupList.map((center) => (
                            <option key={center.id} value={center.id}>
                              {center.group_name}
                            </option>
                          ))}
                        </Form.Select>

                        {/* DTMF Dropdown */}
                        <Form.Select
                          style={{ flex: 1 }}
                          name="selectedDtmf"
                          value={campaign.selectedDtmf}
                          onChange={handleChange}
                        >
                          <option value="">DTMF</option>
                          {[...Array(10).keys()].map((num) => (
                            <option
                              key={num}
                              value={num}
                              disabled={campaign.assignedQueues.some(
                                (item) => item.dtmf === String(num)
                              )}
                            >
                              {num}
                            </option>
                          ))}
                        </Form.Select>

                        {/* Add Button */}
                        <Button
                          variant="dark"
                          onClick={() => {
                            if (campaign.selectedQueue && campaign.selectedDtmf) {
                              setCampaign((prev) => ({
                                ...prev,
                                assignedQueues: [
                                  ...prev.assignedQueues,
                                  {
                                    queueId: campaign.selectedQueue,
                                    queueName: callGroupList.find((q) => q.id === campaign.selectedQueue)?.group_name,
                                    dtmf: campaign.selectedDtmf,
                                  },
                                ],
                                selectedQueue: "",
                                selectedDtmf: "",
                              }));
                            }
                          }}
                        >
                          +
                        </Button>
                      </div>
                    )}

                    {/* Table for Added Queues */}
                    {campaign.assignedQueues.length > 0 && (
                      <Table bordered hover style={{ marginTop: "1rem" }}>
                        <thead>
                          <tr>
                            <th>Group</th>
                            <th>DTMF</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaign.assignedQueues.map((item, index) => (
                            <tr key={index}>
                              <td>{item.queueName}</td>
                              <td>{item.dtmf}</td>
                              <td>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => {
                                    setCampaign((prev) => ({
                                      ...prev,
                                      assignedQueues: prev.assignedQueues.filter((_, i) => i !== index),
                                    }));
                                  }}
                                >
                                  –
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </>
                )}


              </div>
            </Form.Group>

            {campaign.template_id == 3 && campaign.campaign_type == 2 && (
              <Form.Group style={{ marginBottom: "1.5rem" }}>
                <Form.Label
                  style={{
                    fontWeight: 500,
                    color: "#495057",
                    marginBottom: "0.5rem",
                  }}
                >
                  Select IVR
                </Form.Label>
                <Form.Select
                  name="ivr"
                  value={campaign.ivr}
                  onChange={handleChange}
                  style={{
                    padding: "0.5rem 0.75rem",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    transition:
                      "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                  }}
                >
                  <option>Select...</option>
                  {ivrList.map((ivr) => (
                    <option key={ivr.id} value={ivr.id}>
                      {" "}
                      {ivr.flow_name}{" "}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}
          </div>
        );
      case 4:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />
            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Check
                type="radio"
                label="Doesn't require script"
                name="scriptOption"
                value="none"
                checked={campaign.scriptOption === "none"}
                onChange={handleChange}
                style={{ marginBottom: "0.5rem" }}
              />
              <Form.Check
  type="radio"
  label="Existing script"
  name="scriptOption"
  value="existing"
  checked={campaign.scriptOption === "existing"}
  onChange={handleChange}
  style={{ marginBottom: "0.5rem" }}
/>

{campaign.scriptOption === "existing" && (
  <>
    <Form.Select
      name="selectedScript"
      value={campaign.selectedScript}
      onChange={handleChange}
      style={{
        padding: "0.5rem 0.75rem",
        borderRadius: "6px",
        border: "1px solid #ced4da",
        marginBottom: "20px",
        transition:
          "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      }}
    >
      <option value="">Select Existing Script</option>
      {scripts.map((sc) => (
        <option key={sc.id} value={sc.id}>
          {sc.title}
        </option>
      ))}
    </Form.Select>

    {/* Show description only if a script is selected */}
    {campaign.selectedScript && (
      <>
        {(() => {
          const selected = scripts.find(
            (sc) => sc.id === campaign.selectedScript
          );
          return (
            selected && (
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "10px",
                  marginBottom: "20px",
                  background: "#f9f9f9",
                }}
              >
                <h6 style={{ marginBottom: "0.5rem" }}>
                 Short-Description- {selected.short_description}
                </h6>
                <p style={{ marginBottom: 0 }}>Description- {selected.description}</p>
              </div>
            )
          );
        })()}
      </>
    )}
  </>
)}

              <Form.Check
                type="radio"
                label="New script"
                name="scriptOption"
                value="new"
                checked={campaign.scriptOption === "new"}
                onChange={handleChange}
                style={{ marginBottom: "1rem" }}
              />
            </Form.Group>

            {campaign.scriptOption === "new" && (
              <>
                <Form.Group style={{ marginBottom: "1.5rem" }}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Title
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="scriptTitle"
                    value={campaign.scriptTitle}
                    onChange={handleChange}
                    placeholder="Enter script title"
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                  />
                </Form.Group>

                <Form.Group style={{ marginBottom: "1.5rem" }}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Description
                  </Form.Label>
                  <div
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      overflow: "hidden",
                    }}
                  >
                    <CKEditor
                      editor={ClassicEditor}
                      data={campaign.scriptDescription}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setCampaign((prev) => ({
                          ...prev,
                          scriptDescription: data,
                        }));
                      }}
                      onReady={(editor) => {
                        editor.editing.view.change((writer) => {
                          writer.setStyle(
                            "height",
                            "300px",
                            editor.editing.view.document.getRoot()
                          );
                        });
                      }}
                    />
                  </div>
                </Form.Group>

                <Form.Group style={{ marginBottom: "1.5rem" }}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Short Description
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="scriptShortDescription"
                    value={campaign.scriptShortDescription}
                    onChange={handleChange}
                    placeholder="Summary of the script"
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                  />
                </Form.Group>
              </>
            )}
          </div>
        );
      case 5:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />
            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Record calls:
              </Form.Label>
              <div>
                <Form.Check
                  type="radio"
                  id="doNotRecord"
                  label="Do not record"
                  name="callRecording"
                  value="do_not_record"
                  checked={campaign.callRecording === "do_not_record"}
                  onChange={handleChange}
                  style={{ marginBottom: "0.5rem" }}
                />
                <Form.Check
                  type="radio"
                  id="record"
                  label="Record"
                  name="callRecording"
                  value="record"
                  checked={campaign.callRecording === "record"}
                  onChange={handleChange}
                  style={{ marginBottom: "1rem" }}
                />
              </div>
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Select DID
              </Form.Label>
              <Select
                isMulti
                name="did"
                options={numbersList.map((num) => ({
                  value: num.id,
                  label: num.actual_number,
                }))}
                value={numbersList
                  .filter((num) => campaign.did?.includes(num.id))
                  .map((num) => ({
                    value: num.id,
                    label: num.actual_number,
                  }))}
                onChange={(selected) => {
                  setCampaign((prev) => ({
                    ...prev,
                    did: selected.map((opt) => opt.value),
                  }));
                }}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    padding: "2px",
                  }),
                }}
              />
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Time between calls (seconds)
              </Form.Label>
              <Form.Control
                type="number"
                name="timeBetweenCalls"
                value={campaign.timeBetweenCalls}
                onChange={handleChange}
                placeholder="Time interval before calling a new contact"
                style={{
                  padding: "0.5rem 0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  transition:
                    "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                }}
              />
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Max retries
              </Form.Label>
              <Form.Control
                type="number"
                name="max_retries"
                value={campaign.max_retries}
                onChange={handleChange}
                placeholder="Maximum retries per contact (Limit is 10)"
                min="1"
                max={10}
                style={{
                  padding: "0.5rem 0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  transition:
                    "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                }}
              />
            </Form.Group>
          </div>
        );
      case 6:
        return (
          <div>
            <hr style={{ margin: "1.5rem 0", borderColor: "#eaeaea" }} />
            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Outbound Campaign duration
              </Form.Label>
              <p
                style={{
                  color: "#6c757d",
                  fontSize: "0.875rem",
                  marginBottom: "0.5rem",
                }}
              >
                Outbound Campaign will not run outside of these dates
              </p>
              <Row>
                <Col md={6}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Start date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="start_date"
                    value={campaign.start_date || ""}
                    onChange={handleChange}
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                      width: "100%",
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    End date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="end_date"
                    value={campaign.end_date || ""}
                    onChange={handleChange}
                    min={campaign.start_date || ""}
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                      width: "100%",
                    }}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Week days
              </Form.Label>
              <p
                style={{
                  color: "#6c757d",
                  fontSize: "0.875rem",
                  marginBottom: "0.5rem",
                }}
              >
                Select days to run campaign
              </p>
              <Button
                size="sm"
                onClick={handleSelectAllToggle}
                style={{ marginBottom: "1rem" }}
                disabled={
                  campaign.start_date &&
                  campaign.end_date &&
                  campaign.start_date === campaign.end_date
                }
              >
                {selectAll ? "Deselect All" : "Select All"}
              </Button>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "2rem",
                }}
              >
                {/* {[
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ].map((day) => (
                  <div
                    key={day}
                    style={{
                      padding: "0.5rem 0",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      id={day}
                      label={day}
                      name="weekDays"
                      value={day}
                      checked={campaign.weekDays?.includes(day)}
                      onChange={(e) => {
                        const { value, checked } = e.target;
                        setCampaign((prev) => ({
                          ...prev,
                          weekDays: checked
                            ? [...(prev.weekDays || []), value]
                            : (prev.weekDays || []).filter((d) => d !== value),
                        }));
                      }}
                    />
                  </div>
                ))} */}
                {allDays.map((day) => {
                  const isSameDay = campaign.start_date && campaign.end_date && campaign.start_date === campaign.end_date;
                  const selectedDay = campaign.weekDays?.[0];
                  return (
                  <div key={day} style={{ padding: "0.5rem 0", borderBottom: "1px solid #f0f0f0" }}>
                    <Form.Check
                      type="checkbox"
                      id={day}
                      label={day}
                      value={day}
                      checked={campaign?.weekDays?.includes(day)}
                      onChange={(e) => handleDayChange(day, e.target.checked)}
                      disabled={isSameDay && day !== selectedDay}
                    />
                  </div>
                  )
                })}
              </div>
            </Form.Group>

            <Form.Group style={{ marginBottom: "1.5rem" }}>
              <Form.Label
                style={{
                  fontWeight: 500,
                  color: "#495057",
                  marginBottom: "0.5rem",
                }}
              >
                Outbound Campaign hours
              </Form.Label>
              <p
                style={{
                  color: "#6c757d",
                  fontSize: "0.875rem",
                  marginBottom: "0.5rem",
                }}
              >
                Outbound Campaign will not run outside of these hours
              </p>
              <Row>
                <Col md={6}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    From
                  </Form.Label>
                  <Form.Control
                    type="time"
                    name="startHour"
                    value={campaign.startHour || ""}
                    onChange={handleChange}
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                      width: "100%",
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label
                    style={{
                      fontWeight: 500,
                      color: "#495057",
                      marginBottom: "0.5rem",
                    }}
                  >
                    To
                  </Form.Label>
                  <Form.Control
                    type="time"
                    name="endHour"
                    value={campaign.endHour || ""}
                    onChange={handleChange}
                    style={{
                      padding: "0.5rem 0.75rem",
                      borderRadius: "6px",
                      border: "1px solid #ced4da",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                      width: "100%",
                    }}
                  />
                </Col>
              </Row>
            </Form.Group>
          </div>
        );
      case 7:
          return (
            <div>
              {/* <h5 style={{ marginBottom: "1.5rem" }}>SMS/Webhook Settings</h5> */}
              <>
                <Form.Group
                  style={{ marginBottom: "1.5rem", display: "flex", gap: 10, marginTop: "1.5rem" }}
                >
                  <Form.Check
                    type="checkbox"
                    label="Send SMS on Success"
                    name="sendSmsOnSuccess"
                    checked={campaign.sendSmsOnSuccess}
                    onChange={handleChange}
                  />
                  {campaign.sendSmsOnSuccess && (
                    <>
                      <Form.Select
                        name="duration"
                        value={campaign.duration}
                        onChange={handleChange}
                        style={{ width: 250 }}
                      >
                        <option value="">Select duration</option>
                        {Array.from({ length: 60 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Select
                        name="successSmsWebhook"
                        value={campaign.successSmsWebhook}
                        onChange={handleChange}
                        style={{ width: 250 }}
                      >
                        <option value="">Select SMS Webhook</option>
                        {smsWebhooks?.map((webhook) => (
                          <option key={webhook.id} value={webhook.id}>
                            {webhook.webhook_name}
                          </option>
                        ))}
                      </Form.Select>
                    </>
                  )}
                </Form.Group>
                <Form.Group
                  style={{ marginBottom: "1.5rem", display: "flex", gap: 10 }}
                >
                  <Form.Check
                    type="checkbox"
                    label="Send SMS on Fail"
                    name="sendSmsOnFail"
                    checked={campaign.sendSmsOnFail}
                    onChange={handleChange}
                  />
                  {campaign.sendSmsOnFail && (
                    <Form.Select
                      name="failSmsWebhook"
                      value={campaign.failSmsWebhook}
                      onChange={handleChange}
                      style={{ width: 250 }}
                    >
                      <option value="">Select SMS Webhook</option>
                      {smsWebhooks?.map((webhook) => (
                        <option key={webhook.id} value={webhook.id}>
                          {webhook.webhook_name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Form.Group>

                <Form.Group
                  style={{ marginBottom: "1.5rem", display: "flex", gap: 10 }}
                >
                  <Form.Check
                    type="checkbox"
                    label="Enable Webhook"
                    name="enableWebhook"
                    checked={campaign.enableWebhook}
                    onChange={handleChange}
                  />
                  {campaign.enableWebhook && (
                    <Form.Select
                      name="webhook"
                      value={campaign.webhook}
                      onChange={handleChange}
                      style={{ width: 250 }}
                    >
                      <option value="">Select Webhook</option>
                      {webhooks?.map((webhook) => (
                        <option key={webhook.id} value={webhook.id}>
                          {webhook.webhook_name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Form.Group>
              </>
              {(campaign.template_id === "1" || campaign.template_id === "2") && campaign.campaign_type == 2 && (
                <Form.Group
                  style={{ marginBottom: "1.5rem", display: "flex", gap: 10 }}
                >
                  <Form.Check
                    type="checkbox"
                    label="Send Sms on DTMF"
                    name="enableSmsOnDtmf"
                    checked={campaign.enableSmsOnDtmf}
                    onChange={handleChange}
                    style={{ width: 250 }}
                  />
                  {campaign.enableSmsOnDtmf && (
                    <Form.Select
                      name="smsOnDtmf"
                      value={campaign.smsOnDtmf}
                      onChange={handleChange}
                    >
                      <option value="">Select Sms Webhook</option>
                      {smsWebhooks?.map((webhook) => (
                        <option key={webhook.id} value={webhook.id}>
                          {webhook.webhook_name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Form.Group>
              )}
              {campaign.template_id === "2" && campaign.campaign_type == 2 && (
                <>
                  <Form.Group
                    style={{ marginBottom: "1.5rem", display: "flex", gap: 10 }}
                  >
                    <Form.Check
                      type="checkbox"
                      label="Send Sms to Agent on Patch Success"
                      name="enableSmsOnPatchSuccess"
                      checked={campaign.enableSmsOnPatchSuccess}
                      onChange={handleChange}
                    />
                    {campaign.enableSmsOnPatchSuccess && (
                      <Form.Select
                        name="smsOnPatchSuccess"
                        value={campaign.smsOnPatchSuccess}
                        onChange={handleChange}
                        style={{ width: 250 }}
                      >
                        <option value="">Select Sms Webhook</option>
                        {smsWebhooks?.map((webhook) => (
                          <option key={webhook.id} value={webhook.id}>
                            {webhook.webhook_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Form.Group>
                  <Form.Group
                    style={{ marginBottom: "1.5rem", display: "flex", gap: 10 }}
                  >
                    <Form.Check
                      type="checkbox"
                      label="Send Sms to Agent on Patch Failed"
                      name="enableSmsOnPatchFailed"
                      checked={campaign.enableSmsOnPatchFailed}
                      onChange={handleChange}
                    />
                    {campaign.enableSmsOnPatchFailed && (
                      <Form.Select
                        name="smsOnPatchFailed"
                        value={campaign.smsOnPatchFailed}
                        onChange={handleChange}
                        style={{ width: 250 }}
                      >
                        <option value="">Select Sms Webhook</option>
                        {smsWebhooks?.map((webhook) => (
                          <option key={webhook.id} value={webhook.id}>
                            {webhook.webhook_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Form.Group>
                </>
              )}
            </div>
          );

      default:
        return null;
    }
  };

function validateStep(currentStep) {
  switch (currentStep) {
    case 3:
      if (campaign.campaign_type == 2) {
        if (campaign.template_id == 0) {
          return (
            !!campaign.campaign_name.trim() &&
            !!campaign.voice_file &&
            campaign.call_group.length > 0
          );
        } else if (campaign.template_id == 1) {
          return (
            !!campaign.campaign_name.trim() &&
            !!campaign.menu_voice_file &&
            campaign.call_group.length > 0 &&
            campaign.dtmf.length > 0 &&
            !!campaign.menu_wait_time &&
            !!campaign.re_prompt &&
            (!campaign.welcome_file.enabled || !!campaign.welcome_file.selected) &&
            (!campaign.no_input_file.enabled || !!campaign.no_input_file.selected) &&
            (!campaign.wrong_input_file.enabled || !!campaign.wrong_input_file.selected) &&
            (!campaign.thanks_file.enabled || !!campaign.thanks_file.selected)
          );
        } else if (campaign.template_id == 2) {
          return (
            !!campaign.campaign_name.trim() &&
            !!campaign.menu_voice_file &&
            campaign.call_group.length > 0 &&
            !!campaign.menu_wait_time &&
            !!campaign.re_prompt &&
            !!campaign.no_agent_file.selected &&
            campaign.assignedQueues.length > 0 &&
            (!campaign.welcome_file.enabled || !!campaign.welcome_file.selected) &&
            (!campaign.no_input_file.enabled || !!campaign.no_input_file.selected) &&
            (!campaign.wrong_input_file.enabled || !!campaign.wrong_input_file.selected) &&
            (!campaign.thanks_file.enabled || !!campaign.thanks_file.selected)
          );
        } else if (campaign.template_id == 3) {
          return (
            !!campaign.campaign_name.trim() &&
            !!campaign.ivr &&
            campaign.call_group.length > 0
          );
        }
      } else {
        return (
          !!campaign.campaign_name.trim() &&
          campaign.call_group.length > 0
        );
      }
    case 4:
      if (campaign.scriptOption === "new") {
        return (
          !!campaign.scriptTitle.trim() &&
          !!campaign.scriptDescription.trim() &&
          !!campaign.scriptShortDescription.trim()
        );
      } else if (campaign.scriptOption === "existing") {
        return !!campaign.selectedScript;
      }
      return true;
    case 5:
      return (
        campaign.did.length > 0 &&
        !!campaign.timeBetweenCalls &&
        !!campaign.max_retries
      );
    case 6:
      return (
        !!campaign.start_date &&
        !!campaign.end_date &&
        campaign.weekDays.length > 0 &&
        !!campaign.startHour &&
        !!campaign.endHour
      );
    case 7:
      return (
        (!campaign.sendSmsOnSuccess || !!campaign.successSmsWebhook) &&
        (!campaign.sendSmsOnFail || !!campaign.failSmsWebhook) &&
        (!campaign.enableWebhook || !!campaign.webhook) &&
        (!campaign.enableSmsOnDtmf || !!campaign.smsOnDtmf) &&
        (!campaign.enableSmsOnPatchSuccess || !!campaign.smsOnPatchSuccess) &&
        (!campaign.enableSmsOnPatchFailed || !!campaign.smsOnPatchFailed)
      );

    default:
      return true;
  }
}


  return (
    <>
      {/* <StatsBar /> */}
      <Container
        style={{
          padding: 0,
          margin: "2rem auto",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <Card style={{ border: "none" }}>
          <Card.Header
            style={{
              backgroundColor: "#f8f9fa",
              padding: "0",
              borderRadius: "8px 8px 0 0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "1rem 1.5rem",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              <Button
                onClick={() => navigate("/campaigns")}
                style={{
                  backgroundColor: "#4f46e5",
                  color: "white",
                  border: "none",
                  padding: "0.5rem 1.25rem",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  transition: "all 0.2s ease",
                  ":hover": {
                    backgroundColor: "#4338ca",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <FaArrowLeft
                  style={{ marginRight: "0.5rem", fontSize: "0.9rem" }}
                />
                Back to Outbound Campaigns
              </Button>
            </div>

            <Nav
              variant="tabs"
              defaultActiveKey="#first"
              style={{
                borderBottom: "none",
                padding: "0 1rem",
              }}
            >
              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => {setStep(1);}}
                  active={step === 1}
                  style={{
                    color:
                      step === 1
                        ? "#4f46e5"
                        : completedSteps.includes(1)
                        ? "#10b981"
                        : invalidSteps.includes(1)
                        ? "#ff4841"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 1
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(1)
                        ? "3px solid #10b981"
                        : invalidSteps.includes(1)
                        ? "3px solid #ff4841"
                        : "none",
                  }}
                >
                  <FaMicrochip style={{ fontSize: "1.1rem" }} />
                  Dialer Type
                  {completedSteps.includes(1) && step !== 1 && (
                    <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                  )}
                  {invalidSteps.includes(1) && step !== 1 && (
                    <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                  )}
                </Nav.Link>
              </Nav.Item>

              {campaign.campaign_type == 2 && (
                <Nav.Item>
                  <Nav.Link
                    href="#"
                    onClick={() => {setStep(2)}}
                    active={step === 2}
                    style={{
                      color:
                        step === 2
                          ? "#4f46e5"
                          : completedSteps.includes(2)
                          ? "#10b981"
                          : invalidSteps.includes(2)
                          ? "#ff4841"
                          : "#6b7280",
                      fontWeight: 600,
                      padding: "1rem 1.5rem",
                      borderRadius: "0",
                      transition: "all 0.3s ease",
                      backgroundColor: "transparent",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      fontSize: "0.9375rem",
                      position: "relative",
                      zIndex: 2,
                      boxShadow: "none",
                      borderBottom:
                        step === 2
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(2)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(2)
                          ? "3px solid #ff4841"
                          : "none",
                    }}
                  >
                    <FaNewspaper style={{ fontSize: "1.1rem" }} />
                    Template
                    {completedSteps.includes(2) && step !== 2 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(2) && step !== 2 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                  </Nav.Link>
                </Nav.Item>
              )}

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(3)}
                  active={step === 3}
                  style={{
                      color:
                        step === 3
                          ? "#4f46e5"
                          : completedSteps.includes(3)
                          ? "#10b981"
                          : invalidSteps.includes(3)
                          ? "#ff4841"
                          : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                        step === 3
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(3)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(3)
                          ? "3px solid #ff4841"
                          : "none",
                  }}
                >
                  <FaGlobe style={{ fontSize: "1.1rem" }} />
                  General
                    {completedSteps.includes(3) && step !== 3 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(3) && step !== 3 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(4)}
                  active={step === 4}
                  style={{
                      color:
                        step === 4
                          ? "#4f46e5"
                          : completedSteps.includes(4)
                          ? "#10b981"
                          : invalidSteps.includes(4)
                          ? "#ff4841"
                          : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                        step === 4
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(4)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(4)
                          ? "3px solid #ff4841"
                          : "none",
                  }}
                >
                  <FaFileAlt style={{ fontSize: "1.1rem" }} />
                  Script
                    {completedSteps.includes(4) && step !== 4 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(4) && step !== 4 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(5)}
                  active={step === 5}
                  style={{
                      color:
                        step === 5
                          ? "#4f46e5"
                          : completedSteps.includes(5)
                          ? "#10b981"
                          : invalidSteps.includes(5)
                          ? "#ff4841"
                          : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                        step === 5
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(5)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(5)
                          ? "3px solid #ff4841"
                          : "none",
                  }}
                >
                  <FaCog style={{ fontSize: "1.1rem" }} />
                  Settings
                    {completedSteps.includes(5) && step !== 5 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(5) && step !== 5 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(6)}
                  active={step === 6}
                  style={{
                      color:
                        step === 6
                          ? "#4f46e5"
                          : completedSteps.includes(6)
                          ? "#10b981"
                          : invalidSteps.includes(6)
                          ? "#ff4841"
                          : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                        step === 6
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(6)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(6)
                          ? "3px solid #ff4841"
                          : "none",
                  }}
                >
                  <FaCalendarAlt style={{ fontSize: "1.1rem" }} />
                  Schedule
                    {completedSteps.includes(6) && step !== 6 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(6) && step !== 6 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                  <Nav.Link
                    href="#"
                    onClick={() => setStep(7)}
                    active={step === 7}
                    style={{
                      color:
                        step === 7
                          ? "#4f46e5"
                          : completedSteps.includes(7)
                          ? "#10b981"
                          : invalidSteps.includes(7)
                          ? "#ff4841"
                          : "#6b7280",
                      fontWeight: 600,
                      padding: "1rem 1.5rem",
                      borderRadius: "0",
                      transition: "all 0.3s ease",
                      backgroundColor: "transparent",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      fontSize: "0.9375rem",
                      position: "relative",
                      zIndex: 2,
                      boxShadow: "none",
                      borderBottom:
                        step === 7
                          ? "3px solid #4f46e5"
                          : completedSteps.includes(7)
                          ? "3px solid #10b981"
                          : invalidSteps.includes(7)
                          ? "3px solid #ff4841"
                          : "none",
                    }}
                  >
                    <FaCommentDots style={{ fontSize: "1.1rem" }} />
                    Sms
                    {completedSteps.includes(7) && step !== 7 && (
                      <FaCheckCircle style={{ color: "#10b981", marginLeft: "5px" }} />
                    )}
                    {invalidSteps.includes(7) && step !== 7 && (
                      <FaWindowClose style={{ color: "#ff4841", marginLeft: "5px" }} />
                    )}
                  </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body style={{ padding: "2rem" }}>
            <Card.Title style={{ color: "#212529", fontWeight: 500 }}>
              {step === 2 && campaign.campaign_type == 2 && "Template"}
              {step === 3 && "General"}
              {step === 4 && "Script"}
              {step === 5 && "Outbound Campaign Settings"}
              {step === 6 && "Scheduling"}
              {step === 7 && "Sms/Webhook Settings"}
            </Card.Title>
            {renderStep()}
          </Card.Body>
          <Card.Footer
            style={{
              backgroundColor: "#f8f9fa",
              borderTop: "1px solid #eaeaea",
              padding: "1rem",
            }}
          >
            <Row>
              <Col>
                {step > 1 && (
                  <Button
                    variant="secondary"
                    onClick={prevStep}
                    style={{ padding: "0.5rem 1.75rem" }}
                  >
                    Back
                  </Button>
                )}
              </Col>
              <Col style={{ textAlign: "end" }}>
                {step < 7 ? (
                  <Button
                    variant="primary"
                    onClick={nextStep}
                    style={{ padding: "0.5rem 1.75rem", fontWeight: 500 }}
                  >
                    Continue
                  </Button>
                ) : (
                  <Button

                    onClick={handleFormSubmit}
                    variant="success"
                    style={{ padding: "0.5rem 1.75rem", fontWeight: 500 }}
                    disabled={buttonDisable}
                  >
                    Create Outbound Campaign
                  </Button>
                )}
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      </Container>
      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
    </>
  );
};

export default CreateCampaign;
